'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:selectDate');
}

var _invoke = require('../invoke');

/**
 * 选择出行日期
 *
 * TODO: 补全参数和返回值
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof train
 * @static
 * @name selectDate
 * @param {String} date 当前日期
 * @param {Number} days 日期 6.2
 * @param {String} tips 底部提示 6.2
 * @return {Promise<date>}
 * @example
 *  hbnb.train.selectDate('date', '60', '预售期为60天，60天外不可购买')
 *      .then(function(date) {
 *          date = '2015-02-02'
 *      });
 */
module.exports = function(date, days, tips) {
    if (process.env.NODE_ENV !== 'production') {
        debug('date is %s', date);
        debug('days is %s', days);
        debug('tips is %s', tips);
    }

    if (days === undefined) days = 60;
    if (tips === undefined) tips = '预售期为60天，60天外不可购买';

    var p = new Promise(function(resolve, reject) {
        _invoke('train', 'select_date', {
            date: date,
            days: days,
            tips: tips,
            callback: function(date) {
                resolve(date.date);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/select-date.js
// module id = 635
// module chunks = 0